<template>
  <div class="item-cells product" v-if="product.Id">
    <div class="item-cell product-info showTitle pf-medium" v-if="showTitle">
      <img
        class="icon_prefer_prod"
        src="../../assets/images/order/icon_prefer_prod.png"
        alt=""
        v-if="isCustomisedGoods"
      />
      <span>{{ isCustomisedGoods ? '孕产优选' : '商品信息' }}</span>
    </div>
    <div class="item-cell product-info" v-else>
      <div class="item-cell-bd product-title">
        <span class="iconstore"></span>{{ product.businessName }}
      </div>
    </div>
    <div class="item-cell-info product-detail" @click="detail">
      <div class="item-cell-hd">
        <img :src="product.Pic | viewImage(140, 140)" alt="" />
      </div>
      <div class="item-cell-bd product-tpnc">
        <div class="top">
          <div class="name">
            <p class="title pf-medium">{{ product.Title }}</p>
            <p class="price pf-medium">
              <i>&yen;</i>{{ (order.orderPrice / order.num) | priceNum }}
            </p>
          </div>
          <div class="name-item">
            <p class="specification">产品规格：{{ product.Sku }}&nbsp;</p>
            <span class="number">x{{ order.num }}</span>
          </div>
        </div>
        <div class="tag-warper" v-if="isTripTicket602">
          <div
            v-for="(tag, tagIndex) in tags"
            :key="tagIndex"
            class="ticket-item"
          >
            <span class="tag">{{ tag }}</span>
          </div>
          <div v-if="isNeedCard" class="ticket-item">
            <span class="tag" :style="{ color: '#ffa454' }">
              需要携带身份证
            </span>
          </div>
          <div class="ticket-item">
            <span
              class="tag"
              :style="{ color: '#666' }"
              @click.stop="
                () => {
                  showNotice = true
                }
              "
            >
              购买须知
            </span>
          </div>
        </div>
        <p class="labels" v-else>
          <span
            v-if="product.refund_anytime === 1"
            @click="e => this.refundAnytime(e)"
          >
            随时退
          </span>
          <span
            v-if="product.refund_overdue === 1"
            @click="e => this.refundOverdue(e)"
          >
            过期退
          </span>
          <span
            class="no-refund"
            v-if="product.refund_anytime === 0 && product.refund_overdue === 0"
          >
            不可退
          </span>
          <span v-if="product.isPosPay === 1">POS支付</span>
          <span
            v-if="order.skuTag == 8 && order.skuSecType == 601"
            @click.stop="gotoTips"
            class="ticket-tips"
            >购买须知
            <img
              class="icon-right-arrow"
              src="../../assets/images/order/icon_right_arrow.png"
          /></span>
        </p>
      </div>
    </div>
    <div
      class="product-tuan"
      v-if="order.channelType === 4 && order.groupId"
      @click="showGroupDetail"
    >
      <div>
        <img src="../../assets/images/order/icon-tuan.png" class="tuan" />
        <span>拼团详情</span>
      </div>
      <img src="../../assets/images/order/icon-arr.png" class="arr" />
    </div>

    <van-popup
      v-model="showNotice"
      round
      position="bottom"
      closeable
      :style="{ height: '85%' }"
    >
      <BuyNoticePopup :noticeInfo="noticeInfo" :skuInfo="order" />
    </van-popup>

    <van-popup
      v-model="show601"
      round
      position="bottom"
      closeable
      :style="{ height: '85%' }"
    >
      <BuyNotice601Popup
        :noticeInfo="noticeInfo"
        :purchaseType="order.purchaseType === 1"
        :skuName="order.skuName"
      />
    </van-popup>

    <codeModal :visiable="refundAnytimeDialog" title="随时退">
      <div class="refund_anytime_dialog">
        <p class="summary">
          您所购买的服务如未核销未使用随时可退款，3个工作日内完成退款审核
        </p>
        <div class="button">
          <div @click="confirmRefundAnytimeDialog">知道了</div>
        </div>
      </div>
    </codeModal>
    <codeModal :visiable="refundOverdueDialog" title="过期退">
      <div class="refund_overdue_dialog">
        <p class="summary">
          您所购买的服务如未核销未使用，过期后将自动退款至您的支付账户
        </p>
        <div class="button">
          <div @click="confirmRefundOverdue">知道了</div>
        </div>
      </div>
    </codeModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import codeModal from '@/components/newOrder/codeModal'
import { SKUTAG } from '@/plugins/enum'
import { queryBookingNotes } from '@/router/home/components/confirm/product-info/notice/service'
import BuyNotice601Popup from '@/router/home/components/confirm/product-info/notice/BuyNoticePopup.vue'
import BuyNoticePopup from '@/router/home/components/confirm/product-info/notice/third/TicketBuyNoticePopup.vue'
import { Popup } from 'vant'
import {
  E_ORDER_TYPE,
  E_SKUTAG,
  SELF_PHOTO_TYPE_ENUM,
  ORDER_TYPE_FOR_PERIOD
} from '@/config'
export default {
  props: {
    product: {
      type: Object,
      default() {
        return {}
      }
    },
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    orderStatus: {
      type: Number,
      default: -1
    },
    stateDesc: {
      type: String,
      default: ''
    },
    isCustomisedGoods: {
      type: Boolean
    }
  },
  async mounted() {
    const result = await queryBookingNotes(this.order.skuId)
    this.noticeInfo = result
  },
  data() {
    return {
      refundAnytimeDialog: false,
      refundOverdueDialog: false,
      showNotice: false,
      show601: false,
      noticeInfo: {}
    }
  },
  methods: {
    showGroupDetail() {
      // 拼团并且有拼团id 展示入口
      location.href = `/v/order/group/${this.order.groupId}?cmd=share&sharetype=0&refresh=no`
    },
    detail() {
      const { channelType, skuSecType, skuTag, selfPhotoType, payPeriodType } =
        this.order
      // 是否旅游门票601life.cekid.com/v2/ticket/detail/977129?skuId=221819
      if (E_SKUTAG.TRAVEL_TICKET == skuTag && 601 == skuSecType) {
        location.href = `//life.cekid.com/v2/ticket/detail/${this.order.spuId}?&refresh=no&skuId=${this.order.skuId}`
      } else if (this.isTripTicket602) {
        location.href = `//life.cekid.com/v2/ticket/detail/${this.order.spotId}?&refresh=no&skuId=${this.order.skuId}`
      } else {
        if (+channelType === E_ORDER_TYPE.SCAN_BUY) return

        if (
          SELF_PHOTO_TYPE_ENUM.SCAN_BUY == selfPhotoType ||
          (SELF_PHOTO_TYPE_ENUM.CLOUD == selfPhotoType &&
            ORDER_TYPE_FOR_PERIOD.CLOUD_PHOTO_APPEND_CHILD_ORDER ==
              payPeriodType)
        ) {
          return
        }

        if (this.product.userType * 1 === 98) {
          if (this.product.serviceCode && this.product.spuId) {
            location.href = `/y/worker?empId=${this.product.serviceCode}&spuId=${this.product.spuId}`
          }
        } else {
          if (channelType > 1) {
            location.href = `/v/product/${this.order.spuId}?skuId=${
              this.order.skuId || ''
            }&ruleType=${channelType || 1}&ruleId=${
              this.order.ruleId || ''
            }&refresh=no`
          } else {
            location.href = `/v/product/${this.order.spuId}?&refresh=no`
          }
        }
      }
    },
    refundAnytime(e) {
      e.stopPropagation()
      this.refundAnytimeDialog = true
    },
    confirmRefundAnytimeDialog() {
      this.refundAnytimeDialog = false
    },
    refundOverdue(e) {
      e.stopPropagation()
      this.refundOverdueDialog = true
    },
    confirmRefundOverdue() {
      this.refundOverdueDialog = false
    },
    gotoTips() {
      this.show601 = true
      // location.href = `//m.czj100.com/details/guides/ticket/${this.order.skuId}?cmd=share&sharetype=0`
    }
  },
  computed: {
    ...mapState(['selectedCoupon']),
    showTitle() {
      const { skuTag } = this.order
      return +skuTag === E_SKUTAG.POPTRAIN || +skuTag === E_SKUTAG.POPSTORE
    },
    isTripTicket602() {
      const { skuSecType, skuTag } = this.order
      return skuTag === SKUTAG.TICKET && skuSecType === 602
    },
    isNeedCard() {
      return (
        this.order &&
        this.order.collectInfo &&
        this.order.collectInfo &&
        this.order.collectInfo.travelPerson &&
        this.order.collectInfo.travelPerson.reqParam &&
        this.order.collectInfo.travelPerson.reqParam.length > 0
      )
    },
    tags() {
      const tag = []
      const { isSchedule, quickEnter, isAnyTimeRefund } = this.order
      if (isSchedule === 0) {
        tag.push('随买随用')
      } else {
        tag.push('需预约')
      }
      if (quickEnter) {
        tag.push('无需取票')
      } else {
        tag.push('需取票')
      }
      if (isAnyTimeRefund === 1) {
        tag.push('随时退')
      } else if (isAnyTimeRefund === 2) {
        tag.push('条件退')
      } else if (isAnyTimeRefund === 0) {
        tag.push('不可退')
      }
      if (this.product.isExpiredRefund === 1) {
        tag.push('过期退')
      }
      return tag
    },
    // purchaseType() {
    //   const { extInfo = [] } = this.order
    //   const result = extInfo.find(item => item.labelKey === 'purchaseType')
    //   if (result) return result.labelValue
    //   return 0
    // }
  },
  components: {
    codeModal,
    BuyNoticePopup,
    BuyNotice601Popup,
    [Popup.name]: Popup
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.product {
  margin: rem(20px) rem(24px) rem(20px);
  border-radius: rem(16px);

  .item-cell {
    &:first-child {
      .icon-daojiafuwu {
        vertical-align: baseline;
        margin-right: rem(20px);
      }
      .item-cell-ft {
        color: #ff5900;
      }
    }
    .item-cell-bd {
      // text-align: right;

      i {
        margin: 0 rem(3px);
      }
    }
  }
  .product-info {
    padding-bottom: 0;
    font-weight: 600;
    &.showTitle {
      font-size: 0.3rem;
      font-weight: bold;

      .icon_prefer_prod {
        margin: 0 rem(10px) 0 rem(10px);
        width: rem(26px);
        height: rem(32px);
      }
    }
    .product-title {
      font-size: rem(28px) !important;
      color: #121212;
      padding: rem(16px) 0 rem(20px);
      display: flex;
      align-items: center;
    }

    .iconstore {
      display: inline-block;
      width: rem(30px);
      height: rem(30px);
      background: url('../../assets/images/order/icon-store.png') no-repeat
        center center;
      background-size: rem(30px) rem(30px);
      margin-right: rem(10px);
    }

    .item-cell-bd {
      font-size: rem(26px);
    }
    .icon-daojiafuwu {
      vertical-align: baseline;
      margin-right: rem(20px);
    }
    .item-cell-ft {
      color: #ff5900;
    }
  }

  .pay-info {
    .item-cell-hd {
      color: #121212;
    }
    .item-cell-bd {
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item-cell {
      &:first-child {
        @include border(bottom);
        &::after {
          left: rem(20px);
          right: rem(20px);
        }
      }
      &.total-pay,
      &.discount,
      &.act-pay {
        .item-cell-bd {
          font-weight: 600;
        }
      }
      &.discount {
        padding-top: 0;
        padding-bottom: 0;
      }
      &.act-pay {
        font-size: rem(32px);
        .item-cell-bd {
          color: #ff397e;
        }
      }
    }
  }
  .amount {
    padding-top: rem(20px);
    padding-bottom: rem(20px);
  }
  .product-detail {
    align-items: flex-start;
    padding-top: rem(20px);
    padding-bottom: rem(24px);

    &::after {
      left: rem(20px);
      right: rem(20px);
    }
    .item-cell-hd {
      img {
        display: block;
        width: rem(140px);
        height: rem(140px);
        min-width: rem(140px);
        border-radius: rem(8px);
        object-fit: cover;
      }
    }
    .item-cell-bd,
    .item-cell-ft {
      p:last-of-type {
        color: #666;
      }
    }
    .item-cell-ft {
      text-align: right;
    }
    .name {
      display: flex;
      align-items: center;
      margin-right: rem(24px);
      justify-content: space-between;
      .title {
        font-weight: bold;
        font-size: rem(26px);
        color: #262626 !important;
        margin-right: rem(10px);
        word-break: break-all;
        text-align: left;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        display: -webkit-box;
        max-height: 2.4em;
        line-height: 1.25;
        overflow: hidden;
        // max-width: rem(500px);
      }
      .price {
        flex: auto;
        text-align: right;
        font-size: rem(26px);
        font-weight: 500;
        color: #262626 !important;
      }
    }

    .product-tpnc {
      display: flex;
      width: 100%;
      flex-direction: column;
      margin-left: rem(18px);
      justify-content: space-between;

      .top {
        flex: 1;
      }
    }
    .name-item {
      display: flex;
      margin-right: rem(24px);
      flex-direction: row;
      justify-content: space-between;

      .specification {
        color: #999999 !important;
        margin-top: rem(12px);
        font-size: rem(20px);
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-bottom: rem(7px);
      }

      .number {
        margin-top: rem(14px);
        color: #a5a5a5;
        font-size: rem(22px);
        line-height: rem(24px);
        padding-left: rem(30px);
      }
    }

    .labels {
      font-size: rem(22px);
      line-height: rem(28px);

      display: flex;

      .ticket-tips {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: rem(28px);

        .icon-right-arrow {
          width: rem(20px);
          height: rem(20px);
          margin-left: rem(12px);
        }
      }

      .no-refund {
        color: #f5a623;
      }
      > span {
        display: inline-block;
        position: relative;
        padding-right: rem(20px);
        height: rem(28px);
        color: #262626;
        &::after {
          display: block;
          content: '';
          position: absolute;
          top: rem(2px);
          bottom: rem(4px);
          right: rem(10px);
          width: 1px;
          background-color: #262626;
        }
        &:last-child {
          padding-right: 0;
          &::after {
            width: 0;
          }
        }
      }
    }
  }

  .icon-right-arrow {
    width: rem(20px);
    height: rem(20px);
  }

  .product-tuan {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: rem(26px);
    color: #262626;
    line-height: rem(32px);
    padding: rem(22px) 0;
    margin: 0 rem(24px);
    font-weight: bold;
    @include border(top, #f2f2f2);

    .tuan {
      width: rem(39px);
      height: rem(26px);
      margin-right: rem(16px);
    }
    .arr {
      width: rem(20px);
      height: rem(20px);
    }
  }

  .refund_anytime_dialog,
  .refund_overdue_dialog {
    .summary {
      font-size: rem(26px);
      color: #333;
      text-align: left;
      padding: rem(20px) rem(30px);
      line-height: rem(40px);
    }
    .button {
      text-align: center;
      padding: rem(10px) rem(15px);
      font-size: rem(32px);
      line-height: rem(68px);
      @include border(top, #ddd);
    }
  }
}
.item-cell-info {
  display: flex;
  padding-left: rem(24px);
  position: relative;
}
.tag-warper {
  display: flex;
  flex-wrap: wrap;

  .ticket-item {
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    &:not(:last-child)::after {
      content: '';
      display: inline-block;
      margin: 0 rem(10px);
      background-color: #666666;
      width: rem(1px);
      height: rem(24px);
    }

    &:last-child::after {
      content: '';
      display: inline-block;
      width: rem(20px);
      height: rem(20px);
      background: url(https://hzwimspic-1251601690.image.myqcloud.com/c55d1fb0-addf-4b9f-8acf-eba01fd8b720)
        no-repeat;
      background-size: 100%;
    }

    .tag {
      font-size: rem(24px);
      color: #348be6ff;
      line-height: rem(36px);
    }
  }
}
.y-e-ios {
  .product .product-detail .name .title {
    font-weight: 500;
  }
}
</style>
